<div bsModal #mySettingsModal="bs-modal" (onShown)="onShown()" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form *ngIf="active" #mySettingsModalForm="ngForm" (ngSubmit)="save()">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>{{l("MySettings")}}</span>
                    </h5>
                    <button type="button" class="close" aria-label="Close" (click)="close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" *ngIf="user">
                    <tabset class="tab-container tabbable-line">
                        <tab heading="{{l('Profile')}}" customClass="m-tabs__item">
                            <div class="form-group">
                                <label>{{l("Title")}} *</label>
                                <select class="form-control" required [(ngModel)]="user.title" name="Title">
                                    <option *ngFor="let title of titles" [value]="title">{{title}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>{{l("Name")}} *</label>
                                <input #nameInput="ngModel" class="form-control" type="text" name="Name" [(ngModel)]="user.name"
                                    required maxlength="32">
                                <validation-messages [formCtrl]="nameInput"></validation-messages>
                            </div>

                            <div class="form-group">
                                <label>{{l("Surname")}} *</label>
                                <input #surnameInput="ngModel" type="text" name="Surname" class="form-control"
                                    [(ngModel)]="user.surname" required maxlength="32">
                                <validation-messages [formCtrl]="surnameInput"></validation-messages>
                            </div>

                            <div class="form-group">
                                <label>{{l("EmailAddress")}} *</label>
                                <input #emailAddressInput="ngModel" type="email" name="EmailAddress" class="form-control"
                                    [(ngModel)]="user.emailAddress" required email maxlength="256">
                                <validation-messages [formCtrl]="emailAddressInput" [errorDefs]="[{email: l('InvalidEmailAddress')}]"></validation-messages>
                            </div>
                            <div *ngIf="smsEnabled && !isPhoneNumberEmpty">
                                <div class="form-group">
                                    <label>{{l("PhoneNumber")}}<span *ngIf="user.isAdmin">&nbsp;*</span></label>
                                    <div class="input-group">
                                        <app-phone-input [(ngModel)]="user.phoneNumber" name="PhoneNumber" [required]="user.isAdmin"></app-phone-input>
                                        <div class="form-control-feedback text-danger" *ngIf="mySettingsModalForm.controls['PhoneNumber'] && mySettingsModalForm.controls['PhoneNumber'].errors">
                                            <span *ngIf="mySettingsModalForm.controls['PhoneNumber'].errors.invalid">Invalid
                                                phone number</span>
                                            <span *ngIf="mySettingsModalForm.controls['PhoneNumber'].errors.required">This
                                                field is required</span>
                                        </div>

                                        <span *ngIf="!isPhoneNumberConfirmed" id="SpanSmsVerificationUnverified" class="input-group-btn">
                                            <button id="btnSmsVerification" (click)="smsVerify()" class="btn btn-primary"
                                                type="button" tooltip="{{l('YourPhoneNumberIsNotVerified')}}"><i class="fa fa-warning"></i>{{l('Verify')}}</button>
                                        </span>

                                        <span *ngIf="!isPhoneNumberConfirmed" id="SpanSmsVerificationVerified" style="display: none;"
                                            class="input-group-addon" tooltip="{{l('YourPhoneNumberIsVerified')}}">
                                            <i class="la la-check m--font-success"></i>
                                        </span>

                                        <span *ngIf="isPhoneNumberConfirmed" class="input-group-addon" tooltip="{{l('YourPhoneNumberIsVerified')}}">
                                            <i class="la la-check m--font-success"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!smsEnabled || isPhoneNumberEmpty">
                                <div class="form-group">
                                    <label>{{l("PhoneNumber")}}<span *ngIf="user.isAdmin">&nbsp;*</span></label>
                                    <app-phone-input [(ngModel)]="user.phoneNumber" name="PhoneNumber" [required]="user.isAdmin"></app-phone-input>
                                    <div class="form-control-feedback text-danger" *ngIf="mySettingsModalForm.controls['PhoneNumber'] && mySettingsModalForm.controls['PhoneNumber'].errors">
                                        <span *ngIf="mySettingsModalForm.controls['PhoneNumber'].errors.invalid">Invalid
                                            phone number</span>
                                        <span *ngIf="mySettingsModalForm.controls['PhoneNumber'].errors.required">This
                                            field
                                            is required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label>{{l("UserName")}} *</label>
                                <input #userNameInput="ngModel" type="text" [disabled]="!canChangeUserName" class="form-control"
                                    [(ngModel)]="user.userName" name="UserName" required maxlength="32">
                                <span class="m-form__help" *ngIf="!canChangeUserName">{{l("CanNotChangeAdminUserName")}}</span>
                                <validation-messages [formCtrl]="userNameInput"></validation-messages>
                            </div>

                            <div class="form-group" *ngIf="showTimezoneSelection">
                                <label>{{l("Timezone")}}</label>
                                <timezone-combo [(selectedTimeZone)]="user.timezone" defaultTimezoneScope="{{defaultTimezoneScope}}"></timezone-combo>
                            </div>
                        </tab>
                        <tab heading="{{l('TwoFactorLogin')}}" customClass="m-tabs__item" *ngIf="isTwoFactorEnabled && isTwoFactorHostEnabled">
                            <div *ngIf="isTwoFactorGoogleAuthProviderEnabled">
                                <h4>
                                    Google Authenticator
                                </h4>

                                <div [hidden]="!isGoogleAuthenticatorEnabled">
                                    <div>
                                        {{l("ScanQrCodeWithYourMobileApp")}}
                                    </div>
                                    <div class="text-center">
                                        <img [src]="user.qrCodeSetupImageUrl" />
                                    </div>
                                    <small>
                                        {{l("GoogleAuthenticatorReferrerLink")}}: <a href="https://support.google.com/accounts/answer/1066447"
                                            target="_blank" rel="noopener noreferrer">Google Authenticator</a>
                                    </small>
                                </div>

                                <div>
                                    <button type="button" class="btn blue" (click)="updateQrCodeSetupImageUrl(!isGoogleAuthenticatorEnabled)">
                                        {{!isGoogleAuthenticatorEnabled? l("Enable") : "Disable"}}
                                    </button>
                                </div>

                            </div>
                            <div *ngIf="!(user.isAdmin || user.isTwoFactorAuthenticationForced) && isTwoFactorSmsProviderEnabled">
                                <h4>
                                    SMS Authentication
                                </h4>
                                <div *ngIf="user.isSmsAuthenticationEnabled">
                                    SMS messages will be send to {{user.phoneNumber}}
                                </div>
                                <div>
                                    <button type="button" class="btn blue" (click)="toggleSmsAuthentication(!user.isSmsAuthenticationEnabled)"
                                        [disabled]="!isPhoneNumberConfirmed && !user.isSmsAuthenticationEnabled">
                                        {{ !user.isSmsAuthenticationEnabled? l("Enable"): "Disable"}}
                                    </button>
                                    <span *ngIf="!isPhoneNumberConfirmed && !user.isSmsAuthenticationEnabled">Verify
                                        phone number first!</span>
                                </div>

                            </div>
                        </tab>
                    </tabset>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="saving">{{l("Cancel")}}</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!mySettingsModalForm.form.valid || saving"><i
                            class="fa fa-save"></i> <span>{{l("Save")}}</span></button>
                </div>
            </form>
        </div>
    </div>
</div>
<smsVerificationModal #smsVerificationModal (modalSave)="changePhoneNumberToVerified()"></smsVerificationModal>


// WEBPACK FOOTER //
// ./src/app/shared/layout/profile/my-settings-modal.component.html